var render = function render(){
  var _vm$product;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h6', {
    staticClass: "text-overline font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$translate("productMetadata")) + " ")]), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-combobox', {
    attrs: {
      "dense": "",
      "value": _vm.activeProducttypeName,
      "item-value": "value",
      "item-text": "text",
      "label": _vm.$translate('productType'),
      "clearable": _vm.isCustomer,
      "disabled": !_vm.isCustomer,
      "error-messages": _vm.productSavingErrors.producttype,
      "items": _vm.producttypesChoices,
      "outlined": _vm.outlined,
      "hide-details": "auto"
    },
    on: {
      "change": _vm.onProducttypeChange
    }
  })], 1), (_vm$product = _vm.product) !== null && _vm$product !== void 0 && _vm$product.producttype ? _vm._l(_vm.getProductTypeFields(), function (field) {
    return _c('v-col', {
      key: field.code,
      staticClass: "pt-2",
      attrs: {
        "cols": "6",
        "sm": "4"
      }
    }, [field.type == 'choices' ? _c('Select', {
      "class": field.required ? 'font-weight-bold' : null,
      attrs: {
        "value": _vm.product.metadata[field.code],
        "outlined": _vm.outlined,
        "dense": "",
        "label": _vm.fieldLabel(field),
        "clearable": _vm.isCustomer,
        "disabled": !_vm.isCustomer || _vm.isFieldDisabled(field.code),
        "required": field.required,
        "error-messages": _vm.productSavingErrors.metadata ? _vm.productSavingErrors.metadata[field.code] : null,
        "options": _vm._f("fieldOptions")(field),
        "hide-details": "auto"
      },
      on: {
        "input": function input($event) {
          return _vm.$emit('metadata-changed', {
            code: field.code,
            value: $event
          });
        }
      }
    }) : field.type == 'boolean' ? _c('v-select', {
      attrs: {
        "value": _vm.product.metadata[field.code],
        "outlined": _vm.outlined,
        "dense": "",
        "hide-details": "auto",
        "label": _vm.fieldLabel(field),
        "clearable": _vm.isCustomer,
        "disabled": !_vm.isCustomer || _vm.isFieldDisabled(field.code),
        "required": field.required,
        "error-messages": _vm.productSavingErrors.metadata ? _vm.productSavingErrors.metadata[field.code] : null,
        "items": [{
          text: _vm.$translate('yes'),
          value: true
        }, {
          text: _vm.$translate('no'),
          value: false
        }]
      },
      on: {
        "input": function input($event) {
          return _vm.$emit('metadata-changed', {
            code: field.code,
            value: $event
          });
        }
      }
    }) : _c('v-text-field', {
      "class": field.required ? 'font-weight-bold' : null,
      attrs: {
        "value": _vm.product.metadata[field.code],
        "outlined": _vm.outlined,
        "hide-details": "auto",
        "dense": "",
        "label": _vm.fieldLabel(field),
        "clearable": _vm.isCustomer,
        "disabled": !_vm.isCustomer || _vm.isFieldDisabled(field.code),
        "required": field.required,
        "format": _vm.fieldFormatForField(field),
        "type": _vm.fieldTypeForField(field),
        "error-messages": _vm.productSavingErrors.metadata ? _vm.productSavingErrors.metadata[field.code] : null
      },
      on: {
        "input": function input($event) {
          return _vm.$emit('metadata-changed', {
            code: field.code,
            value: $event
          });
        },
        "keydown": function keydown($event) {
          return _vm.$emit('keydown', $event);
        }
      }
    })], 1);
  }) : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }